import React, { useMemo } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import { registerIcons } from "@fluentui/react/lib/Styling";
import { Send28Filled } from "@fluentui/react-icons";
import { GPT4SparkleIcon, JTCShieldIcon } from "./components/ModelSelector/ModelSelectorIcons";

import "./index.css";

import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";
import LoginPage from "./pages/login/LoginPage";
import { AppError } from "./pages/AppError";
import { AppStateProvider } from "./state/AppProvider";
import { AuthProvider, useAuthContext } from "./auth/AuthContext";

const AppRoutes = () => {
    const { isActiveUser, isMsalInitialized, isLoggingOut } = useAuthContext();

    const activeLayoutChild = isActiveUser ? (
        <AppStateProvider>
            <Chat />
        </AppStateProvider>
    ) : (
        <LoginPage isLoadingAuth={!isMsalInitialized} />
    );

    const router = useMemo(
        () =>
            createBrowserRouter([
                {
                    path: "/",
                    element: <Layout />,
                    errorElement: <AppError />,
                    children: [
                        {
                            index: true,
                            element: activeLayoutChild
                        },
                        {
                            path: ":assistantId",
                            element: activeLayoutChild
                        },
                        {
                            path: "*",
                            lazy: () => import("./pages/NoPage")
                        }
                    ]
                }
            ]),
        [isActiveUser, isMsalInitialized, isLoggingOut]
    );

    return <RouterProvider router={router} />;
};

const App = () => (
    <React.StrictMode>
        <AuthProvider>
            <AppRoutes />
        </AuthProvider>
    </React.StrictMode>
);

initializeIcons();

registerIcons({
    icons: {
        Send28Filled: <Send28Filled />,
        GPT4Sparkle: <GPT4SparkleIcon />,
        JTCShield: <JTCShieldIcon />
    }
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
